const Features = (props: any) => {
  return (
    <div className="bg-white border border-gray-700 w-full lg:w-[48%] flex flex-col p-4 gap-4">
      <h2 className="border-b border-gray-300 text-lg font-normal ">
        Features And Finishes
      </h2>
      <p className="text-justify">{props.features}</p>
    </div>
  );
};

export default Features;
